// extracted by css-extract-rspack-plugin
module.exports =  {"titleSubtext":"ServiceItemListDialog__titleSubtext___fKQ4n"};